import { ConfiguredPrefixesSubscription } from "../../graphql/generated/operations";

/**
 * @param {ConfiguredPrefixesSubscription | undefined} data
 * @returns {string[] | undefined}
 */
export const formatter = (data) =>
  data?.configuredPrefixes.map(({ network }) => network);
